module.exports = __webpack_public_path__ + "img/popular-categories-2.852e9070.png";